<template>
  <div class="donation">
    <PageBanner />
    <Breadcrumbs />

    <section class="content">
      <div class="container">
        <h2 class="h4">中國歷史教材參考</h2>
        <p>「共享教育」得到「孫國棟中國教育基金」捐出由著名的歷史學家孫國棟編著，錢穆校訂，在六、七十年代受香港學校普遍使用的中國歷史教科書，作為免費共享中國歷史書的藍本，再重新編整適合香港在廿十一世紀使用的中國歷史教科書。</p>
        <div class="row">
          <div class="col-sm-6">
            <img
              src="@/assets/img/history/chinese_history_img_1.jpg"
              alt="中國歷史教材"
              class="img-fluid"
            >
          </div>
          <div class="col-sm-6">
            <img
              src="@/assets/img/history/chinese_history_img_2.jpg"
              alt="中國歷史教材"
              class="img-fluid"
            >
          </div>
        </div>
        <div class="space"></div>
        <h2 class="h4">世界歷史科教材參考</h2>
        <p>「共享教育」獲得作者張行健先生及出版社青年書屋惠賜《動盪的時代》的電子版版權。此書深入淺出，羅列史家觀點，供學生從不同角度思考，不贅於史事以免沉悶，實開當時世界史中文著作風氣之先。</p>
        <div class="row">
          <div class="col-sm-6">
            <img
              src="@/assets/img/history/human_history.jpg"
              alt="世界歷史科教材"
              class="img-fluid"
            >
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
  import PageBanner from "@/components/pageBanner.vue";
  import Breadcrumbs from "@/components/breadcrumbs.vue";
  export default {
    name: "",
    components: {
      PageBanner,
      Breadcrumbs
    }
  };
</script>